/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminDocumentDto } from '../../models/admin-document-dto';
import { CreateAdminDocumentDto } from '../../models/create-admin-document-dto';

export interface AdminDocumentControllerCreate$Params {
      body: CreateAdminDocumentDto
}

export function adminDocumentControllerCreate(http: HttpClient, rootUrl: string, params: AdminDocumentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, adminDocumentControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminDocumentDto>;
    })
  );
}

adminDocumentControllerCreate.PATH = '/api/adminDocument';
